var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found pt-12"},[_c('h1',[_vm._v("404")]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('FinLexiconEntryNotFound.entry_not_found_text'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }